import type { QueryFromUrlTransformer } from '@atlassian/jira-common-query-param-adapter/src/model/index.tsx';
import { ORDER_DIRECTION } from '../model/constants/order-direction.tsx';
import { ORDER_FIELD } from '../model/constants/order-field.tsx';
import type { Query } from '../model/index.tsx';
import type { OrderField, OrderDirection } from '../model/order.tsx';

const getOrderEntity = <T,>(
	target: {
		[key: string]: T;
	},
	value: T,
	defaults: T,
): T => (Object.values(target).includes(value) ? value : defaults);

export const orderFieldFromUrlParam = (field: OrderField): OrderField =>
	getOrderEntity(ORDER_FIELD, field, ORDER_FIELD.NAME);

export const orderDirectionFromUrlParam = (direction: OrderDirection): OrderDirection =>
	getOrderEntity(ORDER_DIRECTION, direction, ORDER_DIRECTION.DESC);

export const pageFromUrlParam = (page: string): number =>
	typeof Number(page) === 'number' && Number(page) >= 1 ? Number(page) : 1;

export const queryFromUrl: QueryFromUrlTransformer<Query> = ({
	filter,
	orderDirection,
	orderField,
	page,
}) => ({
	filter: filter || '',
	orderDirection: orderDirectionFromUrlParam(orderDirection),
	orderField: orderFieldFromUrlParam(orderField),
	page: pageFromUrlParam(page),
});
